export const UPDATTE_PROFILE_ITEM_START = 'UPDATTE_PROFILE_ITEM_START';
export const UPDATTE_PROFILE_ITEM_SUCCESS = 'UPDATTE_PROFILE_ITEM_SUCCESS';
export const UPDATTE_PROFILE_ITEM_FAILURE = 'UPDATTE_PROFILE_ITEM_FAILURE';

export const UPDATTE_PROFILE_ITEM_RESET = 'UPDATTE_PROFILE_ITEM_RESET';